export enum SustainabilityTabEnum {
  ReportProject = 'reportProject',
  CertifiedProjects = 'certifiedProjects',
  Statistics = 'statistics',
}
